import { cn } from "../../../shared/landing-page/utils";
import "./card.scss";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  transparent?: boolean;
}

export const Card: React.FC<CardProps> = ({ className, children, transparent, ...props }) => {
  const transparentClass = transparent ? "Card-transparent" : "";
  return (
    <div className={cn("Card", transparentClass, className)} {...props}>
      {children}
    </div>
  );
};

interface CardContentProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardContent: React.FC<CardContentProps> = ({ className, children, ...props }) => {
  return (
    <div className={cn("CardContent", className)} {...props}>
      {children}
    </div>
  );
};
